module.exports = __webpack_public_path__ + "img/comfort.458b8322.png";